<template>
  <div id="hangxian">
    <div style="margin-left: 25px;margin-top: 10px;text-align: left;">
      航线：
      <Select v-model="id" style="width:200px" @on-change="changeHangxian">
        <Option v-for="item in hangxianList" :value="item.id" :key="item.id">{{
          item.name
        }}</Option>
      </Select>
      <button class="layui-btn layui-btn-normal" @click="addLine">添加航线</button>

      <button class="layui-btn layui-btn-normal" @click="addNewStations">添加数据</button>

      <button class="layui-btn layui-btn-normal" @click="deleteSelect">批量删除</button>

      <button class="layui-btn layui-btn-normal" @click="importData">excel导入</button>


    </div>
    <table
      class="layui-hide"
      id="hangxianTable"
      lay-filter="hangxianTable"
    ></table>
    <Modal
        v-model="importExcel"
        title="预报数据导入"
        :mask-closable="false"
        width="700"
        footer-hide
        class-name="focastModel"
    >
        <input id="upload" type="file" @change="importfxx(this)" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" v-if="importExcel"/>
        <div>
            1. 导入前，建议您 <a href="/static/FpointImportHangxian.xlsx" class="btn btn-success btn-xs" target="_blank">下载模板</a> 并详细参阅以下说明；<br>
            2. 按照指定格式整理好 Excel 文件；<br>
                a. 经度、纬度，必填，均为数值，建议只保留小数点后不超过2位；<br>
                b. 级别：必填，示例（走行站位）；（可选： 走航站位、潜标站、连续观测站、地质、生化）<br>
            3. 所有列请勿填入单位，请勿改动各列顺序；<br>
            4. 第一行为表头，第二行为示例（跳过不导入），数据将从第三行开始导入；<br>
            5. 在 Excel 中，清除 Excel 格式（带格式可能导入失败）；<br>
            6. 导入 Excel 文件时在收到返回提示前请勿进行其他操作。<br>
        </div>
    </Modal>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  data() {
    return {
      Mondata: [],
      tableData: [],
      hangxianList: [],
      id: null,
      importExcel: false,
      type: {
        zhzw: '走航站位',
        qbz: '潜标站',
        lxgcz: '连续观测站',
        dz: '地质',
        sh: '生化'
      },
      name: {
        '走航站位': 'zhzw',
        '潜标站': 'qbz:',
        '连续观测站': 'lxgcz',
        '地质': 'dz',
        '生化': 'sh'
      },
      layuiTable: null
    };
  },
  mounted() {
    let t = this;
    layui.use('table', function () {
      t.layuiTable = layui.table;
      $.post(t.$ipConfig.getTyhphoonAllLine).then(data => {
        t.hangxianList = data.dataList;
        t.id = data.dataList[data.dataList.length - 1].id;
        t.initTable();
      })
    })

  },
  destroyed() {
  },
  methods: {
    initTable(){
        let t = this;
          var table = t.layuiTable;
          table.render({
              elem: '#hangxianTable',
              url: t.$ipConfig.getFishLineInfo + '&thisid=' + t.id,
              method: 'post',
              response: {
                  statusCode: 999 //重新规定成功的状态码为 200，table 组件默认为 0
              },
              parseData: function (res) { //res 即为原始返回的数据
                  return {
                  "code": res.status, //解析接口状态
                  "msg": res.message, //解析提示文本
                  "data": res.dataList //解析数据列表
                  };
              },
              // toolbar: '#toolbarDemo', //开启头部工具栏，并为其绑定左侧模板
              defaultToolbar: [''],
              title: '用户数据表',
              cols: [[
                  {type:'checkbox'}
                  ,{type: 'numbers', title: '序号', width: 80,align:'center', unresize: true, sort: true}
                  , {field: 'lon', title: '经度', align:'center'}
                  , {field: 'lat', title: '纬度', align:'center'}
                  , {field: 'stanum', title: '级别', align:'center', templet: function(d){
                      return t.type[d.stanum]
                  }}
                  , {title: '操作', align:'center', toolbar: '#barDemo', width: 150}
              ]],
              id: 'hangxianTableReload',
              page: false
          });

          //头工具栏事件
          table.on('toolbar(hangxianTable)', function(obj){
          var checkStatus = table.checkStatus(obj.config.id);
          switch(obj.event){
              case 'addNewStations':
              var html = `<div style="margin-top: 10px;margin-left: 10px;">经度：<input value="" class="lon ivu-input ivu-input-default" style="width: 100px"/> 纬度：<input value="" style="width: 100px" class="lat ivu-input ivu-input-default"/>
              级别：<select class="stanum ivu-select ivu-select-single ivu-select-default" style="width: 100px;height: 32px;border: 1px solid #dcdee2;border-radius: 4px;">
              <option value="zhzw">走航站位</option><option value="qbz">潜标站</option>
              <option value="lxgcz">连续观测站</option><option value="dz">地质</option>
              <option value="sh">生化</option></select></div>`;
              layer.open({
                  type: 1,
                  title: '添加数据',
                  skin: 'layui-layer-rim', //加上边框
                  content: html,
                  area: ['500px', '200px'], //宽高
                  btn: ['保存','取消'],
                  success:function(){
                  },
                  yes: function () {
                      $.post(t.$ipConfig.insertLineDetail + `&Longitude=${$('.lon').val()}&Latitude=${$('.lat').val()}&thisid${t.id}&dataCode=${$('.stanum option:selected').val()}`).then(function(e){
                          t.$Message.success({
                              content: '添加成功',
                              duration: 5
                          });
                      })
                      table.reload('hangxianTableReload');
                      layer.closeAll(0);
                  },
                  btn2:function(){
                      layer.closeAll(0); //关闭当前窗口
                  }
              });
              break;
          }
          });

          //监听行工具事件
          table.on('tool(hangxianTable)', function (obj) {
          var data = obj.data;
          //console.log(obj)
          if (obj.event === 'del') {
              layer.confirm('确认删除?', function (index) {
                  if(index){
                      $.post(t.$ipConfig.deleteFishLine + `&thisid=${data.id}`).then(function(e){
                          t.$Message.success({
                              content: '删除成功',
                              duration: 5
                          });
                      })
                  }
                  table.reload('hangxianTableReload');
                  layer.close(index);
              });
          } else if (obj.event === 'edit') {
              var html = `<div style="margin-top: 10px;margin-left: 10px;">经度：<input value="${data.lon}" class="lon ivu-input ivu-input-default" style="width: 100px"/> 纬度：<input value="${data.lat}" style="width: 100px" class="lat ivu-input ivu-input-default"/>
              级别：<select class="stanum ivu-select ivu-select-single ivu-select-default" style="width: 100px;height: 32px;border: 1px solid #dcdee2;border-radius: 4px;">`;
              if(data.stanum == 'zhzw'){
                  html += `<option value="zhzw" selected>走航站位</option>`;
              }else{
                  html += `<option value="zhzw">走航站位</option>`;
              }
              if(data.stanum == 'qbz'){
                  html += `<option value="qbz" selected>潜标站</option>`;
              }else{
                  html += `<option value="qbz">潜标站</option>`;
              }
              if(data.stanum == 'lxgcz'){
                  html += `<option value="lxgcz" selected>连续观测站</option>`;
              }else{
                  html += `<option value="lxgcz">连续观测站</option>`;
              }
              if(data.stanum == 'dz'){
                  html += `<option value="dz" selected>地质</option>`;
              }else{
                  html += `<option value="dz">地质</option>`;
              }
              if(data.stanum == 'sh'){
                  html += `<option value="sh" selected>生化</option></select></div>`;
              }else{
                  html += `<option value="sh">生化</option></select></div>`;
              }
              layer.open({
              type: 1,
              title: '编辑航线点',
              skin: 'layui-layer-rim', //加上边框
              content: html,
              area: ['500px', '200px'], //宽高
              btn: ['修改','取消'],
              success:function(){
              },
              yes: function () {
                  $.post(t.$ipConfig.updateFishLine + `&Longitude=${$('.lon').val()}&Latitude=${$('.lat').val()}&thisid=${data.id}&systemname=${$('.stanum option:selected').val()}`).then(function(e){
                      t.$Message.success({
                          content: '修改成功',
                          duration: 5
                      });
                  })
                  table.reload('hangxianTableReload');
                  layer.closeAll(0);
              },
              btn2:function(){
                  layer.closeAll(0); //关闭当前窗口
              }
              });
          }
          });
    },
    addNewStations() {
      let t = this;
      var html = `<div style="margin-top: 10px;margin-left: 10px;">经度：<input value="" class="lon ivu-input ivu-input-default" style="width: 100px"/> 纬度：<input value="" style="width: 100px" class="lat ivu-input ivu-input-default"/>
        级别：<select class="stanum ivu-select ivu-select-single ivu-select-default" style="width: 100px;height: 32px;border: 1px solid #dcdee2;border-radius: 4px;">
        <option value="zhzw">走航站位</option><option value="qbz">潜标站</option>
        <option value="lxgcz">连续观测站</option><option value="dz">地质</option>
        <option value="sh">生化</option></select></div>`;
        layer.open({
            type: 1,
            title: '添加数据',
            skin: 'layui-layer-rim', //加上边框
            content: html,
            area: ['500px', '200px'], //宽高
            btn: ['保存','取消'],
            success:function(){
            },
            yes: function () {
                $.post(t.$ipConfig.insertLineDetail + `&Longitude=${$('.lon').val()}&Latitude=${$('.lat').val()}&dataCode=${$('.stanum option:selected').val()}&thisid=${t.id}`).then(function(e){
                    t.$Message.success({
                        content: '添加成功',
                        duration: 5
                    });
                  t.initTable();
                })
                layer.closeAll(0);
            },
            btn2:function(){
                layer.closeAll(0); //关闭当前窗口
            }
        });
    },
    addLine(){
        let t = this;
        var html = `<div style="margin-top: 10px;margin-left: 10px;">航线名称：<input value="" class="user_name ivu-input ivu-input-default" style="width: 300px"/><br>
        航线描述：<input value="" class="content ivu-input ivu-input-default" style="width: 300px;margin-top: 10px"/></div>`;
        layer.open({
            type: 1,
            title: '添加航线',
            skin: 'layui-layer-rim', //加上边框
            content: html,
            area: ['500px', '200px'], //宽高
            btn: ['保存','取消'],
            success:function(){
            },
            yes: function () {
                $.post(t.$ipConfig.host + 'insertLineName' + `&user_name=${$('.user_name').val()}&content=${$('.content').val()}`).then(function(e){
                    t.$Message.success({
                        content: '添加成功',
                        duration: 5
                    });
                })
                $.post(t.$ipConfig.getTyhphoonAllLine).then(data => {
                  t.hangxianList = data.dataList;
                  t.id = data.dataList[data.dataList.length - 1].id;
                  t.initTable();
                })
                // table.reload('hangxianTableReload');
                layer.closeAll(0);
            },
            btn2:function(){
                layer.closeAll(0); //关闭当前窗口
            }
        });
    },
    deleteSelect() {
      var checkStatus = this.layuiTable.checkStatus('hangxianTableReload'); //idTest 即为基础参数 id 对应的值
    },
    importData() {
      this.importExcel = true;
    },
    importfxx(obj) {
      let _this = this;
    //   console.log("xxxxxxxxxxxxxxxxxxxxxxxxxxx1");
      let inputDOM = this.$refs.inputer;
      // 通过DOM取文件数据

      this.file = event.currentTarget.files[0];

      var rABS = false; //是否将文件读取为二进制字符串
      var f = this.file;

      var reader = new FileReader();
      //if (!FileReader.prototype.readAsBinaryString) {
      FileReader.prototype.readAsBinaryString = function(f) {
        var binary = "";
        var rABS = false; //是否将文件读取为二进制字符串
        var pt = this;
        var wb; //读取完成的数据
        var outdata;
        var reader = new FileReader();
        reader.onload = function(e) {
          var bytes = new Uint8Array(reader.result);
          var length = bytes.byteLength;
          for (var i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          var XLSX = require("xlsx");
          if (rABS) {
            wb = XLSX.read(btoa(fixdata(binary)), {
              //手动转化
              type: "base64"
            });
          } else {
            wb = XLSX.read(binary, {
              type: "binary"
            });
          }
          outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]); //outdata就是你想要的东西
          let mapData = [];
          outdata.map((item,index) => {
            if(index > 0){
                //添加
                mapData.push({
                    Latitude: item['纬度'],
                    Longitude: item['经度'],
                    dataCode: _this.name[item['级别']]
                })
                _this.initTable();
                _this.importExcel = false;
            }
          })
          _this.$Message.info('数据导入成功！')
          console.log(outdata)
        };
        reader.readAsArrayBuffer(f);
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
    },
    // 导出表格(vue+iview,改良版)
    exportExcelPuls(dic, name) {
      /*
      参数格式及描述
      dic:[
    	{sheetName:"",col:[],data:[]},
        {sheetName:"",col:[],data:[]},
        {sheetName:"",col:[],data:[]},
        ...
        ]，分别为每页的表名，iview表格列的配置描述，请求到的数据
       name：字符串，导出的Excel文件名
      }
      */
      require.ensure([], () => {
        const {
          export_json_to_excel
        } = require("../common/export2Excel"); //这个地址和页面的位置相关，这个地址是 Export2Excel. js相对于页面的相对位置

        let tableData = [];
        dic.forEach((item, index) => { //整理数据
          tableData[index] = {};
          tableData[index]["sheetName"] = item.sheetName;
          tableData[index]["titles"] = [];
          tableData[index]["keys"] = [];
          for (var i = 0; i < item.col.length; i++) {
            if (item.col[i].slot) {
              tableData[index]["titles"].push(item.col[i].title);
              tableData[index]["keys"].push(item.col[i].slot);
              //如果有插槽，插槽名要和对应的key一样，如不一样需修改代码
            } else {
              if (item.col[i].children) {//判断是否有表头合并
                item.col[i].children.forEach(j => {
                  tableData[index]["titles"].push(
                    item.col[i].title + "-" + j.title
                  );
                  tableData[index]["keys"].push(j.key);
                });
              } else {
                tableData[index]["titles"].push(item.col[i].title);
                tableData[index]["keys"].push(item.col[i].key);
              }
            }
          }
        });

        tableData.forEach((item, index) => {
          tableData[index]["data"] = this.formatJson(
            item.keys,
            dic[index].data
          );
          delete item.keys;
        });
        export_json_to_excel(tableData, name);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    changeHangxian(){
      this.initTable();
    }
  }
};
</script>

<style>
#item3 {
  width: 100%;
  height: 100%;
}
.layui-table-body {
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/common/hangxian.vue